import { render, staticRenderFns } from "./CareerStats.vue?vue&type=template&id=527ea7ba&scoped=true"
import script from "./CareerStats.js?vue&type=script&lang=js&external"
export * from "./CareerStats.js?vue&type=script&lang=js&external"
import style0 from "./CareerStats.vue?vue&type=style&index=0&id=527ea7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ea7ba",
  null
  
)

export default component.exports